import { render } from "./NewDomainDialog.vue?vue&type=template&id=de384786"
import script from "./NewDomainDialog.vue?vue&type=script&lang=js"
export * from "./NewDomainDialog.vue?vue&type=script&lang=js"

import exportComponent from "/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__